import { useEffect } from "react";
import { Form, Col, Row } from "antd";
import useGet from "../hooks/useGet";
import { openConfirmNotification, openErrorNotification } from "../utils/toast";
import CommonButton from "./CommonButton";
import usePut from "../hooks/usePut";
import { CloseOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { FaMessage } from "react-icons/fa6";
import CustomTextArea from "./inputWidgets/CustomTextArea";
import CustomSelect from "./inputWidgets/CustomSelect";

export const CompanyForm = ({ setIsModalOpen }) => {
  const [form] = Form.useForm();
  const loggedInUserData = JSON.parse(sessionStorage.getItem("userData"));
  const id = loggedInUserData.account_no;

  const url = `${process.env.REACT_APP_API_URL}/api/accounts/company/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/accounts/company/`;

  const params = {
    limit: 20,
    sort_by: "LicenseNo",
    order: "desc",
  };
  const query = new URLSearchParams(params).toString();
  const licenseUrl = `${process.env.REACT_APP_API_URL}/api/licenses/?${query}`;
  const { data: licenseData } = useGet(licenseUrl);

  const licenseOptions =
    licenseData?.data?.map((item) => ({
      label: item.LicenseName,
      value: item.LicenseNo,
    })) || [];

  const { data, loading } = useGet(url);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(putUrl);

  const onFinish = (values) => {
    try {
      putAction(values);
      setIsModalOpen(false);
    } catch (error) {
      openErrorNotification("Something went wrong");
      console.log(error);
    }
  };

  //toast for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
    }
  }, [putData, putLoading, putError]);

  const onReset = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        if (data?.data) {
          form.setFieldsValue({
            Contact: data?.data?.Contact,
            Advertise: data?.data?.Advertise,
            LicenseNo: data.data.LicenseNo ? data.data.LicenseNo : null,
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          console.log({ error });
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form]);

  const buttonsData = [
    {
      label: "Apply",
      icon: <CheckCircleOutlined />,
      onClick: () => form.submit(),
    },
    {
      label: "Cancel",
      icon: <CloseOutlined />,
      onClick: onReset,
    },
  ];

  return (
    <Form
      validateTrigger={"onChange"}
      form={form}
      onFinish={onFinish}
      scrollToFirstError
      layout={"vertical"}
      autoComplete={"off"}
    >
      <div className=" bg-white rounded-[4px] overflow-hidden">
        <div className="bg-gray-200 py-[8px] px-[3px] rounded-sm flex items-center mb-2 p-2">
          <FaMessage className="ml-2" />
          <h2 className="text-[14px] font-[Poppins] text-black ml-2">
            Company
          </h2>
        </div>

        <div className="mt-4 px-2 ">
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <CustomTextArea
                label="Contact"
                name="Contact"
                placeholder="Contact"
                rows={4}
                maxLength={400}
              />
            </Col>
            <Col span={24}>
              <CustomTextArea
                label="Advertise"
                name="Advertise"
                placeholder="Advertise"
                rows={4}
                maxLength={400}
              />
            </Col>
            <Col span={24}>
              <CustomSelect
                label="License"
                name="LicenseNo"
                options={licenseOptions}
                placeholder="Please select"
                type={"License"}
              />
            </Col>
          </Row>
        </div>

        <div className="flex justify-center items-center pt-3">
          <CommonButton buttonsData={buttonsData} />
        </div>
      </div>
    </Form>
  );
};
